import styled from '@emotion/styled'
import { whiteMQ } from '../../theme'

interface Props {
  lead?: boolean
  labelWithMobile?: boolean
  wizard?: boolean
  primary?: boolean
  whiteMQ?: MediaQuery
}

const H1 = styled.h1<Props>(
  ({ theme }) => theme.fontSmooth,
  ({ theme }) => ({
    color: theme.colors.primary,
    fontFamily: theme.fonts.families.headline,
    fontSize: '36px',
    lineHeight: '40px',
    fontWeight: 'bold',
    letterSpacing: '1.8px',
    [theme.mediaQueries.maxDesktop]: {
      fontSize: '22px',
      lineHeight: '26px',
      letterSpacing: '1.1px',
    },
  }),
  (props) =>
    props.lead && {
      fontSize: '42px',
      fontWeight: 'normal',
      letterSpacing: '2.1px',
      lineHeight: '46px',
      color: 'white',
      [props.theme.mediaQueries.maxDesktop]: {
        fontSize: '26px',
        lineHeight: '30px',
        letterSpacing: '1.3px',
      },
    },
  (props) =>
    props.wizard && {
      fontSize: props.theme.fonts.sizes.H1.wizard,
      fontWeight: 500,
      letterSpacing: '0.04em',
      padding: 0,
      margin: '1em',
      lineHeight: '1.3em',
    },
  ({ primary, theme }) =>
    primary && {
      color: theme.colors.main.primary,
    }
)

export default H1
